module.exports = __webpack_public_path__ + "static/img/son19.2428e82c.png";